<template>
  <v-container class="stepper-wrapper" fluid>
    <v-row class="ma-0 fill-height">
      <v-col class="d-table fill-height pa-1">
        <component  
          v-if="componentToShow"
          :is="componentToShow.component"
          :ref="componentToShow.ref"
          :key="componentToShow.component"
          @submit-payments="submitPaymentDetails"
          v-on="$listeners"
        />
      </v-col>
    </v-row>
    <v-row class="flex-grow-0 ma-0">
      <v-col class="d-flex pa-2">
        <v-btn small icon color="primary" @click="exitRequest">
          <v-icon size="30">mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn small color="primary" class="mr-2" @click="$emit('step', false)">
          <v-icon>mdi-step-backward</v-icon>
          <span>{{ $t('label.back') }}</span>
        </v-btn>
        <v-btn small color="primary" @click="submitPaymentDetails">
          <span>{{ $t('label.next') }}</span>
          <v-icon>mdi-play</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ShippingInstruction from '@/mixins/ShippingInstruction.js'
import ShippingInstructionPaymentsCmaCgm from '@/components/elements/shipping-instruction/ShippingInstructionPaymentsCmaCgm.vue'
import ShippingInstructionPaymentsMaersk from '@/components/elements/shipping-instruction/ShippingInstructionPaymentsMaersk.vue'
import ShippingInstructionPaymentsMSC from '@/components/elements/shipping-instruction/ShippingInstructionPaymentsMSC.vue'

export default {
  name: 'ShippingInstructionPayments',
  props: [],
  mixins: [ShippingInstruction],
  components: {
    ShippingInstructionPaymentsCmaCgm,
    ShippingInstructionPaymentsMaersk,
    ShippingInstructionPaymentsMSC
  },
  data() {
    return {
       paymentComponents: {
        MAERSK: {
          component: 'ShippingInstructionPaymentsMaersk',
          ref: 'maerskPayments',
        },
        CMACGM: {
          component: 'ShippingInstructionPaymentsCmaCgm',
          ref: 'cmaCgmPayments',
        },
        MSC: {
          component: 'ShippingInstructionPaymentsMSC',
          ref: 'mscPayments',
        },
      },
    }
  },
  computed: {
    componentToShow() {
      const company = (this.company || '').trim().toUpperCase()
      return this.paymentComponents[company] || null
    },
  },
  methods: {
    // Submit
    async submitPaymentDetails() {
      if (!this.componentToShow) return
      const ref = this.$refs[this.componentToShow.ref]
      if (!ref) return
      const validated = typeof ref.validateForm === 'function' ? ref.validateForm() : true
      if (!validated) return
      await ref.submit()
      this.$emit('step', true)
    }
  },
}
</script>

<style scoped>
.stepper-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
}
/*.row {
  border: solid 1px red;
}
.col {
  border: solid 1px orange;
}*/
</style>
